<template lang="pug">
div
  #preloader(v-if="gameLaunching|| favListAction")
    #loader
  template(v-if="!pageLoading")
    .globby.s2
      template(v-if="visibleItems.length > 0")
        template(v-for="game in filteredList()")
          .gggl
            a(href="javascript:void(0)" @click='launchGame(game.game_code, game.game_name)')
              .iimg
                img(:src="'/new/img/game_icon/JILI2/ID_'+game.game_code+'.jpg'")
            .prov
              img(:src="`/new/img/provider/jili.png`")
            .fav.aaa
              i.fa-heart.pointer(:class="checkFav(game.game_code)" @click="favAction('JILI2',game.game_code,game.game_name,'SLOT','/new/img/game_icon/JILI2/ID_'+game.game_code+'.jpg')")
            .name {{game.game_name}}
    .load(v-if="visibleItems.length < listToDisplay.length" @click="loadMore")
      | Load more 
      span.loaded {{ visibleItems.length }} /
      | {{ listToDisplay.length }}
  template(v-else)
    .text-white.my-2.text-center
      i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
</template>
<script>
import config from '@/config'
import _ from "lodash";
export default {
  props: {
    searchinput:{
      type: String,
      default: ""
    }
  },
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      gameList:[],
      imageUrl:"",
      page: 0,
      loading: false,
      pageLoading:false,
      gameLaunching:false,
      listToDisplay: [],
      temp:[],
      offList:[],
      visibleItems: [], // Items currently displayed
      perPage: 15, // Number of items per load
      currentPage: 1,
      favListAction: false,
      // ],
      gameOrder:[
        {id: "49"},
        {id: "103"},
        {id: "109"},
        {id: "403"},
        {id: "399"},
        {id: "263"},
        {id: "300"},
        {id: "299"},
        {id: "180"},
        {id: '51'},
        {id: '209'},
        {id: '223'},
        {id: '77'},
        {id: '110'},
        {id: '134'},
        {id: '102'},
        {id: '47'},
        {id: '92'},
        {id: '183'},
        {id: "181"},
        {id: '85'},
        {id: '137'},
        {id: '35'},
        {id: '144'},
        {id: '38'},
        {id: '16'},
        {id: '45'},
        {id: '27'},
        {id: '33'},
        {id: '30'},
        {id: '48'},
        {id: '145'},
        {id: '142'},
        {id: '17'},
        {id: '164'},
        {id: '135'},
        {id: '223'},
        {id: '198'},
        {id: '87'},
        {id: '191'},
        {id: '6'},
        {id: '172'},
        {id: '43'},
        {id: '101'},
        {id: '5'},
        {id: '136'},
        {id: '58'},
        {id: '130'},
        {id: '9'},
        {id: '36'},
        {id: '126'},
        {id: '76'},
        {id: '4'},
        {id: '108'},
        {id: '176'},
        {id: '40'},
        {id: '14'},
        {id: '100'},
        {id: '2'},
        {id: '91'},
        {id: '13'},
        {id: '21'},
        {id: '106'},
        {id: '23'},
        {id: '146'},
        {id: '225'},
        {id: '67'},
        {id: '116'},
        {id: '78'},
        {id: '166'},
        {id: 'Keno'},
        {id: '115'},
        {id: '46'},
        {id: '153'},
        {id: '61'},
        {id: '63'},
        {id: '62'},
      ],
      excludeList:["63", "61", "62", "64", "66"]
    }
  },
  computed:{
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    matchedLocale(){
      switch(this.getLanguage){
        case "en":
          return "en"
        case "ph":
          return "ph"
        default :
          return "en"
      }
    },
    favList(){
			return this.$store.getters.getFavlist.filter((x)=>x.game_type === "SLOT")
		}
  },
  mounted(){
    // window.scroll(0,0)
    this.getProviderGameOfflist()
    
  },
  methods:{
    checkGame(code){
      if(this.excludeList.includes(code)){
        return false
      }else{
        return true
      }
    },
    getProviderGameOfflist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let provider_code = "JILI2"
        this.$store
          .dispatch("user/getProviderGameOfflist", { account_id, auth_token, provider_code })
          .then(response => {
            if (response.success == true) {
							this.offList = response.data
              this.getGameList()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }else{
				this.getGameList()
			}
    },
    getGameList(){ 
      var vm = this
      this.pageLoading = true
			var url = config.getJiliList()
      this.$http.post(url, {
        "game_category": "1"
      }).then(
        successResponse => {
          if(successResponse){
            if (typeof successResponse.data.status == "string") {
              this.feedback.success = successResponse.status == "200";
            } else {
              this.feedback.success = successResponse.status == 200;
            }
            this.feedback.status = successResponse.status;
            if (this.feedback.success == true) {
              this.gameList = successResponse.data
              this.listToDisplay = this.gameList.filter(obj1 => 
                !this.offList.some(obj2 => obj1.game_code === obj2.game_id) && !this.excludeList.includes(obj1.game_code)
              )
              const reOrderList = this.gameOrder.map(x => x.id);
              const customSort = (item1, item2) => {
                const index1 = reOrderList.indexOf(item1.game_code);
                const index2 = reOrderList.indexOf(item2.game_code);

                if (index1 === -1 && index2 === -1) {
                  // If neither element is in order_array, maintain the original order.
                  return 0;
                } else if (index1 === -1) {
                  // If only arr1 is not in order_array, move it to the end.
                  return 1;
                } else if (index2 === -1) {
                  // If only arr2 is not in order_array, move it to the end.
                  return -1;
                }

                // Compare the indices in order_array.
                return index1 - index2;
              };
              this.listToDisplay.sort(customSort)
              this.visibleItems= this.listToDisplay.slice(0, this.perPage)
              this.pageLoading = false
            } else {
              this.pageLoading = false
            }
          }else{
            this.pageLoading = false
          }
        },
        errorResponse => {
          this.pageLoading = false
          console.log(errorResponse)
        }
      );
    },
    loadMore() {
      const start = this.currentPage * this.perPage;
      const newItems = this.listToDisplay.slice(start, start + this.perPage);
      this.visibleItems = [...this.visibleItems, ...newItems];
      this.currentPage++;
    },
    launchGame(game, name){
      if (this.sessionToken) {
        this.gameLaunching = true
				var vm = this
        let player_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let lang_code = "en"
        let game_name = name
        this.$store
          .dispatch("user/launchJili", { player_id, auth_token,game_code, lang_code, game_name})
          .then(response => {
            if (response.success == true) {
							setTimeout(() => {
								window.open(response.data, "_blank")
                vm.gameLaunching = false
							}) 
            } else {
              vm.gameLaunching = false        
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            vm.gameLaunching = false
            if((typeof response.status) != 'object'){
              if(response.status === 'free_credit_detected'){
                this.$swal({
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.free_credit_detected"),
                  showCancelButton: true,
                  type: "info",
                  confirmButtonText: vm.$tc("ui.ok"),
                  cancelButtonText: vm.$tc("ui.deposit"),
                }).then(result => {
                  if (result.value) {
                    vm.$router.push({name:"slot",params:{"custom": true}}).catch(error =>{})
                    
                  } else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      vm.$router.push("/deposit").catch(error =>{})
                    }
                  }
                });
              }else{
                // this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }else{
				$("#logModal").modal("show")
			}
    },
    filteredList(){
      return this.visibleItems.filter((game) =>
        game.game_name.toLowerCase().includes(this.searchinput.toLowerCase())
      );
    },
    favAction(provider,game,name,type,img){
      if (this.sessionToken) {
        if(this.favList.some(obj=> obj.game_code === game)){
          this.removeFav(provider, game)
        }else{
          this.addFav(provider,game,name,type,img)
        }
      }else{
        $("#logModal").modal("show")
      }
    },
    addFav(provider,game,name,type,img){
      if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let game_name = name
        let provider_code = provider
        let game_type = type
        let img_url = img
        this.$store
          .dispatch("user/addFav", { account_id, auth_token,game_code, game_name, provider_code, game_type, img_url })
          .then(response => {
            if (response.success == true) {
							// console.log(response)
              this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
    },
    removeFav(provider, game){
			if (this.sessionToken) {
        this.favListAction = true
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let game_code = game
        let provider_code = provider
        this.$store
          .dispatch("user/removeFav", { account_id, auth_token,game_code, provider_code })
          .then(response => {
            if (response.success == true) {
              // this.getFavlist()
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.favListAction = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.favListAction = false
          });
      }
		},
    checkFav(code){
      if(this.favList.some(obj=> obj.game_code === code)){
        return "fa-solid"
      }else{
        return "fa-regular"
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
  }
}
</script>